import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';

import { CommonImagesModule } from 'src/app/pages/common-images/common-images.module';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { AfterSalesPipelineTrackerComponent } from './after-sales-pipeline-tracker.component';
import { SubStatusUpdateDialogComponent } from './sub-status-update-dialog.component';

@NgModule({
  declarations: [
    AfterSalesPipelineTrackerComponent,
    SubStatusUpdateDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    CommonImagesModule,
    CommonFileUploadModule,
    SharedModule
  ],
  exports: [
    AfterSalesPipelineTrackerComponent,
    SubStatusUpdateDialogComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AfterSalesPipelineTrackerModule { }
